const isDev = process.env.NODE_ENV !== 'production';

const logger = {
  error: isDev ? (...args) => console.error(...args) : () => {},
  warn:  isDev ? (...args) => console.warn(...args)  : () => {},
  log:   isDev ? (...args) => console.log(...args)   : () => {},
};

export default logger;
